export default __webpack_public_path__ + "static/media/Group8854.4b596993.svg";